import type { AiPowerTranslation } from './en';

/** Urdu. Pending review by native speakers, as the note in the interface says. */
export const aiPowerUr: AiPowerTranslation = {
  mcp: {
    preset: {
      label: 'کسی تیار سروس سے شروع کریں',
      other: 'کوئی اور سروس (اس کا پتہ لکھیں)',
      hint: 'یہ وہ پتے ہیں جو سروسز خود شائع کرتی ہیں۔ نام اور پتہ خود بھرنے کے لیے ایک چنیں۔',
      docs: 'اس پتے کے بارے میں سروس کا اپنا صفحہ',
      verified: 'پتہ {{date}} کو سروس کے صفحے سے ملایا گیا۔',
      summaries: {
        'intercom-us': 'Intercom میں گفتگو، رابطے اور مدد مرکز کے مضامین تلاش کریں۔',
        'intercom-eu': 'Intercom میں گفتگو، رابطے اور مدد مرکز کے مضامین تلاش کریں۔',
        gorgias: 'اپنے Gorgias ہیلپ ڈیسک کے ٹکٹ اور گاہک پڑھیں۔',
        stripe: 'Stripe میں گاہک، ادائیگیاں، رکنیتیں اور رقم کی واپسی تلاش کریں۔',
        klaviyo: 'Klaviyo میں گاہک پروفائلز، فہرستیں اور مہم کے نتائج پڑھیں۔',
        calendly: 'Calendly میں دستیابی اور طے شدہ ملاقاتیں دیکھیں۔',
        linear: 'Linear میں مسائل اور پروجیکٹ تلاش کریں اور پڑھیں۔',
        notion: 'Notion میں صفحات اور ڈیٹابیس تلاش کریں اور پڑھیں۔',
        atlassian: 'Jira کے مسائل اور Confluence کے صفحات تلاش کریں اور پڑھیں۔',
        asana: 'Asana میں ٹاسک اور پروجیکٹ تلاش کریں اور پڑھیں۔',
        monday: 'monday.com میں بورڈ اور آئٹم تلاش کریں اور پڑھیں۔',
        sentry: 'Sentry میں خرابیاں اور مسائل تلاش کریں۔',
        github: 'GitHub پر ریپوزٹری، مسائل اور پل ریکویسٹ تلاش کریں اور پڑھیں۔',
      },
      notes: {
        'intercom-us': 'جب آپ کا Intercom ورک اسپیس امریکہ میں ہو تو اسے استعمال کریں۔',
        'intercom-eu': 'جب آپ کا Intercom ورک اسپیس یورپی یونین میں ہو تو اسے استعمال کریں۔',
        gorgias: 'سائن اِن کرتے وقت Gorgias آپ کے اکاؤنٹ کا نام پوچھتا ہے۔',
        stripe: 'OAuth سے سائن اِن کریں، یا Stripe ایجنٹ API کلید کو ٹوکن کے طور پر چسپاں کریں۔',
        linear: 'Linear کا ایک صرف پڑھنے والا پتہ بھی ہے: https://mcp.linear.app/mcp/readonly۔',
        asana:
          'اگر Asana کلائنٹ آئی ڈی مانگے تو Asana کے ڈیولپر کنسول میں ایک ایپ بنائیں اور اسے لکھیں۔',
        github: 'GitHub پر ایک پرسنل ایکسیس ٹوکن بنائیں اور اسے ٹوکن کے طور پر چسپاں کریں۔',
      },
      auth: {
        oauth: 'آپ براؤزر سے سائن اِن کرتے ہیں۔ ٹوکن کی ضرورت نہیں۔',
        oauth_or_token: 'آپ براؤزر سے سائن اِن کرتے ہیں، یا سروس سے ملا ٹوکن چسپاں کرتے ہیں۔',
        token: 'سروس آپ کو ایک ٹوکن دیتی ہے جسے آپ چسپاں کرتے ہیں۔',
      },
    },
    auth: {
      none: 'نہ سائن اِن، نہ ٹوکن',
      token: 'ٹوکن {{masked}}',
      oauth: '{{host}} کے ذریعے سائن اِن',
      needsReconnect: 'سائن اِن کام کرنا بند ہو گیا۔ دوبارہ سائن اِن کریں۔',
      expires: '{{time}} سے پہلے خود نیا ہو جاتا ہے',
    },
    actions: {
      signIn: 'سائن اِن کریں',
      signInAgain: 'دوبارہ سائن اِن کریں',
      signOut: 'سائن آؤٹ کریں',
      edit: 'تبدیل کریں',
      remove: 'ہٹائیں',
      catalog: 'وسائل اور تیار درخواستیں',
      signInLabel: '{{name}} میں سائن اِن کریں',
      signOutLabel: '{{name}} سے سائن آؤٹ کریں',
      editLabel: '{{name}} تبدیل کریں',
      removeLabel: '{{name}} ہٹائیں',
      catalogLabel: 'دیکھیں کہ {{name}} ٹولز کے علاوہ کیا دیتی ہے',
    },
    signIn: {
      title: '{{name}} میں سائن اِن کریں',
      description:
        'آپ سائن اِن کرنے اور Hamnivo کو اجازت دینے کے لیے سروس پر جاتے ہیں، پھر یہاں لوٹ آتے ہیں۔ Hamnivo آپ کا پاس ورڈ کبھی نہیں دیکھتا۔',
      continue: 'سروس پر جائیں',
      manual: 'کلائنٹ آئی ڈی لکھیں',
      manualHint:
        'صرف تب جب سروس نے مانگی ہو: کچھ سروسز Hamnivo کو خود کو درج کرنے نہیں دیتیں۔ وہاں کلائنٹ بناتے وقت نیچے والا ری ڈائریکٹ پتہ استعمال کریں۔',
      redirect: 'ری ڈائریکٹ پتہ',
      clientId: 'کلائنٹ آئی ڈی',
      clientSecret: 'کلائنٹ سیکرٹ',
      clientSecretHint: 'صرف تب جب سروس نے دیا ہو۔',
      needsClient: 'یہ سروس Hamnivo کو خود کو درج کرنے نہیں دیتی۔ سروس سے ملی کلائنٹ آئی ڈی لکھیں۔',
      leaving: 'سروس پر جا رہے ہیں…',
      signedOut: '{{name}} سے سائن آؤٹ ہو گیا۔',
    },
    signOut: {
      title: '{{name}} سے سائن آؤٹ کریں؟',
      body: 'Hamnivo سروس سے کہتا ہے کہ وہ یہ رسائی بھلا دے، اور محفوظ کیا گیا سائن اِن مٹا دیتا ہے۔ ٹولز رہتے ہیں، مگر دوبارہ سائن اِن کرنے یا ٹوکن جوڑنے تک چل نہیں سکتے۔',
      confirm: 'سائن آؤٹ کریں',
    },
    callback: {
      title: 'سائن اِن ہو رہا ہے',
      working: 'سائن اِن مکمل ہو رہا ہے…',
      done: '{{name}} میں سائن اِن ہو گیا۔',
      synced: 'اس کے ٹولز “ٹولز” میں نظر آ رہے ہیں: چالو کرنے سے پہلے ہر ایک کو دیکھ لیں۔',
      syncFailed: 'سائن اِن ہو گیا، مگر ٹولز ابھی درج نہیں ہو سکے۔ سروس کو دوبارہ جانچیں۔',
      refused: 'سروس نے سائن اِن کی اجازت نہیں دی۔',
      failed: 'سائن اِن مکمل نہیں ہوا۔',
      ended:
        'یہ سائن اِن ختم ہو چکا ہے یا کسی اور نے شروع کیا تھا۔ اسے ٹولز کے صفحے سے دوبارہ شروع کریں۔',
      missing: 'یہ صفحہ سائن اِن مکمل کرنے کے لیے ہے۔ ٹولز کے صفحے سے سائن اِن شروع کریں۔',
      back: 'ٹولز پر لوٹیں',
    },
    edit: {
      title: '{{name}} تبدیل کریں',
      description: 'اس کا نام، پتہ یا ٹوکن بدلیں۔',
      label: 'نام',
      url: 'پتہ',
      token: 'نیا ٹوکن',
      tokenHint:
        'محفوظ کیا ہوا رکھنے کے لیے اسے خالی چھوڑیں۔ نیا ٹوکن سائن اِن کی جگہ لیتا ہے۔ یہ خفیہ کر کے رکھا جاتا ہے اور دوبارہ نہیں دکھتا۔',
      removeToken: 'محفوظ ٹوکن ہٹائیں',
      removeSignIn: 'سائن اِن ہٹانے کے لیے “سائن آؤٹ کریں” استعمال کریں۔',
      urlWarning:
        'پتہ بدلنے پر ٹولز جائزے میں لوٹ جاتے ہیں اور سروس کی فہرست دوبارہ پڑھی جاتی ہے۔ محفوظ ٹوکن تبھی رہتا ہے جب نیا پتہ اسی سائٹ پر ہو، اور سائن اِن ختم ہو جاتا ہے۔',
      save: 'تبدیلیاں محفوظ کریں',
      saved: '{{name}} اپ ڈیٹ ہو گئی۔',
      nothing: 'کچھ نہیں بدلا۔',
    },
    remove: {
      title: '{{name}} ہٹائیں؟',
      body: 'اس کے ٹولز بند ہو جاتے ہیں اور فہرست سے ہٹ جاتے ہیں، ان پر رکی درخواستیں منسوخ ہو جاتی ہیں، اور اس کا ٹوکن یا سائن اِن مٹ جاتا ہے۔ انہوں نے جو کیا وہ لاگ میں رہتا ہے۔ وہی پتہ آپ بعد میں دوبارہ جوڑ سکتے ہیں۔',
      confirm: 'ہٹائیں',
      done: '{{name}} ہٹا دی گئی۔',
    },
    catalog: {
      title: '{{name}} کیا دیتی ہے',
      description:
        'پچھلی جانچ میں سروس نے ٹولز کے علاوہ جو وسائل اور تیار درخواستیں درج کیں۔ اقتباس کے نشانوں میں لکھی باتیں سروس کی ہیں۔',
      checked: '{{time}} کو درج',
      neverChecked: 'پہلے سروس کو جانچیں، تب دکھے گا کہ وہ کیا دیتی ہے۔',
      resources: 'وسائل',
      resourcesNote:
        'سروس کے دیے دستاویزات اور ڈیٹا۔ “Read a resource” ٹول والے ایجنٹ صرف وہی پڑھ سکتے ہیں جو آپ چالو کریں۔',
      noResources: 'سروس کوئی وسائل درج نہیں کرتی۔',
      readable: 'ایجنٹ اسے پڑھ سکتے ہیں',
      readableLabel: 'ایجنٹوں کو {{name}} پڑھنے دیں',
      readableHint: 'صرف “Read a resource” ٹول سے۔',
      type: 'قسم',
      size: 'سائز',
      uri: 'پتہ',
      fromService: 'سروس کی طرف سے',
      prompts: 'تیار درخواستیں',
      promptsNote:
        'سروس کی دی ہوئی تیار درخواستیں۔ یہ آپ کے دیکھنے کے لیے درج ہیں؛ ایجنٹ انہیں استعمال نہیں کرتے۔',
      noPrompts: 'سروس کوئی تیار درخواست درج نہیں کرتی۔',
      arguments: 'مانگتی ہے',
      required: 'ضروری',
      needTool:
        'ایجنٹ وسائل “Read a resource” ٹول سے پڑھتے ہیں۔ اسے ٹولز کے صفحے پر جوڑیں، پھر کسی ایجنٹ کو دیں۔',
      saved: 'محفوظ ہو گیا۔',
      loading: 'سروس جو دیتی ہے وہ لوڈ ہو رہا ہے',
    },
  },
  web: {
    badge: 'ویب سائٹ',
    add: 'ویب سائٹ شامل کریں',
    line: {
      reading: 'ابھی پڑھی جا رہی ہے',
      waiting: 'پڑھے جانے کے انتظار میں',
      never: 'ابھی پڑھی نہیں گئی',
      last: 'پڑھی گئی {{time}}',
    },
    dialog: {
      addTitle: 'ویب سائٹ شامل کریں',
      addDescription:
        'Hamnivo کسی ویب سائٹ کے صفحات پڑھتا ہے اور انہیں تازہ رکھتا ہے تاکہ AI ان سے جواب دے سکے۔ یہ سائٹ کی robots.txt کی پابندی کرتا ہے، آہستہ آہستہ پڑھتا ہے اور صرف اسی سائٹ پر رہتا ہے جس کا پتہ آپ دیتے ہیں۔',
      editTitle: 'ویب سائٹ کی ترتیبات',
      brand: 'برانڈ',
      url: 'ویب سائٹ کا پتہ',
      urlHint:
        'وہ صفحہ جہاں سے پڑھنا شروع کرنا ہے، جیسے https://example.com/help/۔ صرف اسی فولڈر کے صفحات پڑھے جاتے ہیں۔',
      urlRequired: 'ویب سائٹ کا پتہ درج کریں۔',
      urlInvalid: 'https:// سے شروع ہونے والا پورا پتہ درج کریں۔',
      name: 'نام',
      nameHint: 'ذرائع کی فہرست میں نظر آتا ہے۔ خالی چھوڑنے پر سائٹ کا نام استعمال ہوتا ہے۔',
      mode: 'کیا پڑھنا ہے',
      modeSite: 'پوری سائٹ',
      modeSiteHint: 'اس کا سائٹ میپ اور صفحات کے درمیان لنکس، پتے کے فولڈر کے اندر۔',
      modePage: 'صرف یہی صفحہ',
      modePageHint: 'صرف وہ پتہ جو آپ نے درج کیا۔',
      maxPages: 'زیادہ سے زیادہ صفحات',
      maxPagesHint: '1 سے 500 تک۔',
      maxPagesInvalid: '1 سے 500 تک کا مکمل عدد درج کریں۔',
      maxDepth: 'کتنے لنکس آگے جانا ہے',
      maxDepthHint: 'پہلے صفحے سے گنتی۔ 0 رکھنے پر صرف پہلا صفحہ اور سائٹ میپ پڑھے جاتے ہیں۔',
      maxDepthInvalid: '0 سے 5 تک کا مکمل عدد درج کریں۔',
      schedule: 'دوبارہ پڑھنا',
      visibility: 'اس سے جواب کون پا سکتا ہے',
      submit: 'ویب سائٹ شامل کریں',
      save: 'تبدیلیاں محفوظ کریں',
      added: '{{name}} شامل ہو گئی۔ Hamnivo ابھی اسے پڑھنا شروع کرتا ہے۔',
      saved: 'ویب سائٹ کی ترتیبات محفوظ ہو گئیں۔',
      later: 'پہلی بار پڑھنے میں چند منٹ لگ سکتے ہیں۔ آپ یہ صفحہ چھوڑ سکتے ہیں۔',
    },
    schedule: { daily: 'ہر روز', weekly: 'ہر ہفتے', manual: 'صرف جب میں کہوں' },
    panel: {
      title: 'ویب سائٹ',
      address: 'پتہ',
      reads: 'کیا پڑھتی ہے',
      readsSite: 'پوری سائٹ: {{pages}} صفحات تک، {{depth}} لنکس کی گہرائی',
      readsPage: 'صرف یہی صفحہ',
      schedule: 'دوبارہ پڑھنا',
      next: 'اگلی بار پڑھنا {{time}}',
      pages: 'محفوظ کیے گئے صفحات',
      lastRead: 'آخری بار پڑھی گئی',
      never: 'یہ ویب سائٹ ابھی پڑھی نہیں گئی۔',
      state: {
        queued: 'پڑھے جانے کے انتظار میں',
        running: 'ابھی پڑھی جا رہی ہے',
        succeeded: 'پڑھی گئی',
        partial: 'پڑھی گئی، کچھ مسائل کے ساتھ',
        failed: 'پڑھی نہیں جا سکی',
        never: 'ابھی پڑھی نہیں گئی',
      },
      polling: 'ویب سائٹ پڑھے جانے کے دوران Studio ہر چند سیکنڈ میں نئی معلومات چیک کرتا ہے۔',
      summary: {
        title: 'آخری بار پڑھنے میں کیا ہوا',
        added: 'نئے: {{total}}',
        updated: 'بدلے: {{total}}',
        unchanged: 'جیسے تھے ویسے: {{total}}',
        retired: 'ہٹائے گئے: {{total}}',
        sitemaps: 'پڑھے گئے سائٹ میپ: {{total}}',
        leftOut: 'چھوڑے گئے',
        skipped: {
          robots: 'سائٹ پڑھنے والوں کو دور رہنے کو کہتی ہے (robots.txt): {{total}}',
          offsite: 'دوسری سائٹ پر: {{total}}',
          noindex: 'جو صفحات انڈیکس نہ کرنے کو کہتے ہیں: {{total}}',
          type: 'ویب صفحہ یا PDF نہیں: {{total}}',
          duplicate: 'پہلے پڑھے صفحے کی نقل: {{total}}',
          empty: 'پڑھنے کے قابل متن نہیں: {{total}}',
        },
        problems: 'جو پڑھے نہیں جا سکے',
        truncated:
          'صفحات کی حد یا وقت کی وجہ سے پڑھنا تمام صفحات تک پہنچنے سے پہلے رک گیا۔ مزید پڑھنے کے لیے ترتیبات میں حد بڑھائیں۔',
        robots: {
          read: 'سائٹ کی robots.txt پڑھی گئی اور مانی گئی۔',
          missing: 'سائٹ پر robots.txt نہیں ہے، اس لیے تمام صفحات کی اجازت تھی۔',
          unreadable: 'سائٹ کی robots.txt پڑھی نہیں جا سکی، اس لیے کچھ نہیں پڑھا گیا۔',
        },
      },
      actions: {
        sync: 'ابھی پڑھیں',
        syncLabel: '{{name}} ابھی پڑھیں',
        queued: 'Hamnivo تھوڑی دیر میں {{name}} پڑھے گا۔',
        settings: 'ترتیبات',
        settingsLabel: '{{name}} کی ترتیبات',
        showPages: 'صفحات دیکھیں',
        hidePages: 'صفحات چھپائیں',
      },
      pagesList: {
        title: 'صفحات',
        loading: 'صفحات لوڈ ہو رہے ہیں',
        empty: 'ابھی کوئی صفحہ نہیں۔',
        columns: { address: 'پتہ', state: 'حالت', note: 'نوٹ' },
        states: { ok: 'پڑھا گیا', failed: 'نہیں پڑھ سکا', gone: 'ہٹایا گیا' },
      },
    },
  },
  http: {
    title: 'حسبِ ضرورت ٹولز',
    description:
      'اپنی ذاتی ویب سروس جوڑیں۔ اس کی OpenAPI تفصیل امپورٹ کریں، یا ایک درخواست ہاتھ سے لکھیں۔ ہر درخواست ایک ٹول بن جاتی ہے جو کسی بھی ایجنٹ کے استعمال سے پہلے آپ کے جائزے کا انتظار کرتا ہے۔',
    importLabel: 'تفصیل امپورٹ کریں',
    writeLabel: 'درخواست لکھیں',
    loading: 'حسبِ ضرورت ٹولز لوڈ ہو رہے ہیں',
    empty: 'ابھی کوئی حسبِ ضرورت ٹول نہیں۔',
    source: {
      kinds: { openapi: 'امپورٹ کی گئی تفصیل', manual: 'ہاتھ سے لکھی گئی' },
      status: { active: 'چالو', disabled: 'بند' },
      toolStatus: { review: 'جائزے کا انتظار', enabled: 'چالو', disabled: 'بند' },
      tools: 'ٹولز: {{total}}',
      review: 'جائزے کا انتظار: {{total}}',
      auth: {
        none: 'کوئی کریڈینشل نہیں',
        bearer: 'ٹوکن {{masked}}',
        header: '{{header}} ہیڈر میں خفیہ قدر {{masked}}',
      },
      spec: 'تفصیل “{{title}}” {{version}} سے',
      requests: '{{name}} کی درخواستیں',
      open: 'کھولیں',
      openLabel: 'ٹول {{tool}} کھولیں',
      editRequest: 'بدلیں',
      editRequestLabel: 'درخواست {{tool}} بدلیں',
      imported: 'امپورٹ کی گئی: بدلنے کے لیے اسے دوبارہ امپورٹ کریں۔',
      addRequest: 'درخواست جوڑیں',
      importMore: 'مزید امپورٹ کریں',
      edit: 'بدلیں',
      editLabel: '{{name}} بدلیں',
      turnOff: 'بند کریں',
      turnOn: 'چالو کریں',
      remove: 'ہٹائیں',
      removeLabel: '{{name}} ہٹائیں',
      off: 'یہ سروس بند ہے، اس لیے اس کے ٹولز نہیں چل سکتے۔',
    },
    service: {
      name: 'سروس کا نام',
      nameHint: 'فہرست میں اسے کس نام سے تلاش کریں گے، جیسے “آرڈر سسٹم”۔',
      baseUrl: 'سروس کا پتہ',
      baseUrlHint:
        'ہر درخواست اس پتے کے نیچے جاتی ہے، جیسے https://api.example.com/v1۔ یہ https:// سے شروع ہوتا ہے اور اس میں ? یا # نہیں ہوتا۔',
      auth: {
        legend: 'درخواستیں کیسے سائن اِن کرتی ہیں',
        none: 'کوئی کریڈینشل نہیں',
        noneHint: 'ایسی سروس کے لیے جسے اس کی ضرورت نہیں۔',
        bearer: 'ایک ٹوکن',
        bearerHint: '“Authorization: Bearer …” کی صورت میں بھیجا جاتا ہے۔',
        header: 'ہیڈر میں ایک خفیہ قدر',
        headerHint: 'آپ کے بتائے ہوئے ہیڈر میں بھیجی جاتی ہے۔',
        token: 'ٹوکن',
        tokenHint: 'خفیہ کر کے رکھا جاتا ہے۔ صرف اس کے آخری حروف دکھتے ہیں۔',
        headerName: 'ہیڈر کا نام',
        headerNameHint: 'جیسے X-Api-Key۔',
        value: 'خفیہ قدر',
        valueHint: 'خفیہ کر کے رکھی جاتی ہے۔ صرف اس کے آخری حروف دکھتے ہیں۔',
      },
      errors: {
        name: 'سروس کو ایک نام دیں۔',
        baseUrl: 'پتہ لکھیں، https:// سے شروع کر کے۔',
        token: 'ٹوکن کم از کم 8 حروف کا ہوتا ہے۔',
        headerName: 'حروف، ہندسے، ہائفن اور انڈر سکور استعمال کریں۔',
        value: 'خفیہ قدر لکھیں۔',
      },
    },
    importDialog: {
      title: 'OpenAPI تفصیل امپورٹ کریں',
      titleMore: '{{name}} میں مزید ٹولز امپورٹ کریں',
      description:
        'Hamnivo، JSON یا YAML میں OpenAPI 3 تفصیل پڑھتا ہے اور وہ درخواستیں دکھاتا ہے جنہیں ٹول بنایا جا سکتا ہے۔ جب تک آپ انہیں جوڑتے نہیں، کچھ محفوظ نہیں ہوتا۔',
      where: 'تفصیل کہاں ہے؟',
      paste: 'میرے پاس متن یا فائل ہے',
      address: 'وہ ایک ویب پتے پر ہے',
      text: 'تفصیل',
      textHint: 'JSON یا YAML یہاں چسپاں کریں، یا فائل چنیں۔ 9,00,000 حروف تک۔',
      file: 'فائل چنیں',
      fileTooBig:
        'یہ فائل بہت بڑی ہے۔ جن درخواستوں کی ضرورت نہیں انہیں چھوڑ دیں، یا انہیں ہاتھ سے لکھیں۔',
      specUrl: 'تفصیل کا پتہ',
      specUrlHint:
        'جیسے https://api.example.com/openapi.json۔ Hamnivo اسے اپنے سرور سے پڑھتا ہے، ہر پتے پر لاگو ہونے والے اصولوں کے تحت۔',
      read: 'تفصیل پڑھیں',
      needText: 'پہلے تفصیل چسپاں کریں یا فائل چنیں۔',
      needUrl: 'پہلے تفصیل کا پتہ لکھیں۔',
      found: '“{{title}}” {{version}}: {{count}} درخواستیں ٹول بن سکتی ہیں۔',
      foundUntitled: '{{count}} درخواستیں ٹول بن سکتی ہیں۔',
      none: 'اس تفصیل کی کوئی درخواست ٹول نہیں بن سکتی۔',
      readAgain: 'دوسری تفصیل پڑھیں',
      servers: 'تفصیل کے مطابق سروس یہاں ہے',
      serversHint: 'یہ تفصیل کا متن ہے۔ استعمال سے پہلے پتہ جانچ لیں۔',
      authUnsupported:
        'تفصیل ایسا سائن اِن مانگتی ہے ({{kind}}) جو ٹولز آپ کی طرف سے نہیں کر سکتے۔ اگر سروس ہیڈر میں ٹوکن یا کلید بھی لیتی ہے تو نیچے وہی چنیں۔',
      operations: 'ٹول بننے والی درخواستیں',
      operationsHint:
        'ہر ایک ٹول بنتی ہے جو آپ کے جائزے کا انتظار کرتا ہے۔ جو صرف پڑھتی ہیں وہ آپ کے لیے چن دی گئی ہیں۔ جو کچھ بدلتی ہیں انہیں چننا آپ کا کام ہے، اور ہر استعمال کو کوئی شخص منظور کرتا ہے۔',
      selectReads: 'صرف پڑھنے والی چنیں',
      selectAll: 'سب چنیں',
      selectNone: 'کوئی نہ چنیں',
      chosen: '{{count}} چنی گئیں',
      already: 'اس سروس کا ٹول پہلے سے ہے',
      left: 'اس میں سے چھوڑا گیا:',
      skipped: 'جو درخواستیں ٹول نہیں بن سکتیں ({{count}})',
      submit: 'چنے ہوئے ٹولز جوڑیں',
      needOne: 'کم از کم ایک درخواست چنیں۔',
      added: '{{count}} ٹولز جڑ گئے۔ وہ آپ کے جائزے کا انتظار کرتے ہیں۔',
    },
    endpointDialog: {
      addTitle: 'درخواست لکھیں',
      addTitleTo: '{{name}} میں درخواست جوڑیں',
      editTitle: '{{tool}} بدلیں',
      description:
        'آپ کی سروس جو ایک درخواست سمجھتی ہے۔ اے آئی کو بتایا جاتا ہے کہ وہ کیا کرتی ہے اور کون سی تفصیلات بھرنی ہیں۔',
      editWarning:
        'محفوظ کرنے پر یہ ٹول جائزے میں لوٹ جاتا ہے اور منظوری کا انتظار کرتی درخواستیں ختم ہو جاتی ہیں۔',
      title: 'ٹول کا نام',
      titleHint: 'آپ کی ٹیم کو دکھتا ہے، جیسے “آرڈر تلاش کریں”۔',
      about: 'اے آئی کو بتایا جاتا ہے کہ یہ کیا کرتا ہے',
      aboutHint: 'بتائیں کہ اسے کب استعمال کرنا ہے اور یہ کیا لوٹاتا ہے۔ اسے اے آئی کے لیے لکھیں۔',
      method: 'میتھڈ',
      path: 'پاتھ',
      pathHint:
        '/ سے شروع ہوتا ہے۔ جہاں کوئی قدر جاتی ہے وہاں {orderId} لکھیں، جیسے /orders/{orderId}۔',
      risk: 'یہ کیا کر سکتا ہے',
      riskDefault: 'میتھڈ سے طے کریں',
      details: 'اے آئی جو تفصیلات بھرتا ہے',
      detailsHint: 'ہر ایک وہ قدر ہے جو اے آئی درخواست کے ساتھ دیتا ہے۔',
      noDetails: 'کوئی تفصیل نہیں۔ درخواست جیسی ہے ویسی بھیجی جاتی ہے۔',
      addDetail: 'تفصیل جوڑیں',
      detailLabel: 'تفصیل {{n}}',
      removeDetail: 'تفصیل {{n}} ہٹائیں',
      missing: 'پاتھ میں {{names}} ہے، لیکن اسے کوئی تفصیل نہیں بھرتی۔',
      fill: '{{name}} جوڑیں',
      detail: {
        name: 'نام',
        nameHint: 'اے آئی اسے کیا کہتا ہے: حروف، ہندسے اور انڈر سکور۔',
        place: 'کہاں جاتی ہے',
        places: {
          path: 'پاتھ',
          query: 'کوئری',
          header: 'ہیڈر',
          body: 'JSON باڈی',
        },
        key: 'درخواست میں نام',
        keyHint: 'صرف تب، جب وہ نام سے مختلف ہو۔',
        type: 'قدر کی قسم',
        types: {
          string: 'متن',
          integer: 'پورا عدد',
          number: 'عدد',
          boolean: 'ہاں یا نہیں',
        },
        required: 'ہمیشہ ضروری',
        requiredPath: 'ہمیشہ ضروری، کیونکہ یہ پاتھ میں ہے',
        about: 'یہ کیا ہے',
      },
      errors: {
        title: 'ٹول کو ایک نام دیں۔',
        about: 'بتائیں کہ ٹول کیا کرتا ہے۔',
        path: 'پاتھ / سے شروع کریں۔',
        detailName: 'حروف، ہندسے اور انڈر سکور استعمال کریں، اور حرف سے شروع کریں۔',
        detailDuplicate: 'دو تفصیلوں کا نام ایک ہی ہے۔',
      },
      submitAdd: 'ٹول جوڑیں',
      submitEdit: 'محفوظ کریں',
      added: '{{name}} جڑ گیا۔ وہ آپ کے جائزے کا انتظار کرتا ہے۔',
      saved: '{{name}} محفوظ ہو گیا۔ وہ پھر جائزے میں ہے۔',
    },
    editDialog: {
      title: '{{name}} بدلیں',
      description: 'نام یا پتہ بدلیں، یا کریڈینشل بدل دیں۔',
      name: 'سروس کا نام',
      baseUrl: 'سروس کا پتہ',
      baseUrlWarning:
        'نیا پتہ ٹولز کو جائزے میں لوٹا دیتا ہے۔ کریڈینشل کبھی کسی دوسری سائٹ پر نہیں جاتا۔',
      credential: 'کریڈینشل',
      keep: 'رکھیں',
      replace: 'بدل دیں',
      remove: 'ہٹا دیں',
      save: 'محفوظ کریں',
      saved: '{{name}} محفوظ ہو گیا۔',
      nothing: 'کچھ نہیں بدلا۔',
    },
    removeDialog: {
      title: '{{name}} ہٹائیں؟',
      body: 'اس کے ٹولز بند ہو جاتے ہیں اور فہرست سے ہٹ جاتے ہیں، ان پر انتظار کرتی درخواستیں منسوخ ہو جاتی ہیں، اور اس کا کریڈینشل مٹا دیا جاتا ہے۔ ٹولز نے جو کیا وہ کارروائی لاگ میں رہتا ہے۔',
      confirm: 'ہٹائیں',
      done: '{{name}} ہٹا دیا گیا۔',
    },
    tool: {
      service: 'حسبِ ضرورت سروس',
      request: 'درخواست',
      titleLabel: 'ٹول کا نام',
      descriptionLabel: 'اے آئی کو بتایا جاتا ہے کہ یہ کیا کرتا ہے',
      descriptionHint:
        'اے آئی تفصیل کے الفاظ کی جگہ یہ پڑھتا ہے۔ ٹول چالو کرنے سے پہلے اسے جانچ لیں۔',
      errors: { title: 'ٹول کو ایک نام دیں۔', description: 'بتائیں کہ ٹول کیا کرتا ہے۔' },
    },
  },
  memoryCard: {
    title: 'AI کیا یاد رکھتا ہے',
    open: 'میموری کھولیں',
    none: 'یہاں کچھ یاد نہیں رکھا گیا: یہ وزیٹر ابھی جانا پہچانا کسٹمر نہیں ہے۔',
    off: 'اس برانڈ کا AI میموری استعمال نہیں کرتا، اس لیے یہاں کی کوئی چیز اس کے جوابات تک نہیں پہنچتی۔',
    empty: 'اس کسٹمر کے بارے میں ابھی کچھ یاد نہیں رکھا گیا۔',
    note: 'AI صرف موجودہ ویلیوز استعمال کرتا ہے، اور تب ہی جب کسٹمر نے یاد رکھے جانے کی اجازت دی ہو۔',
    thisChat: 'یہی گفتگو',
    pendingNote: 'جب تک کوئی تصدیق نہ کرے، استعمال نہیں ہوتی۔',
    review: 'جائزہ لیں',
    reviewLabel: '{{label}} کا جائزہ لیں',
    correct: 'درست کریں',
    correctLabel: '{{label}} درست کریں',
    delete: 'حذف کریں',
    deleteLabel: '{{label}} حذف کریں',
    correctTitle: '“{{label}}” درست کریں',
    correctBody: 'نئی ویلیو اس کی جگہ لیتی ہے۔ پرانی ویلیو تاریخ میں رہتی ہے۔',
  },
  playground: {
    title: 'اپنے AI کو آزمائیں',
    description:
      'اس ایجنٹ سے ویسے بات کریں جیسے کوئی کسٹمر کرتا ہے، اسی ماڈل کے ساتھ جو وہ واقعی استعمال کرتا ہے۔ وہ اپنی ہدایات اور اپنی معلومات سے جواب دیتا ہے۔ کچھ محفوظ نہیں ہوتا، کچھ بھی کسی کسٹمر یا ان باکس تک نہیں پہنچتا، اور کوئی ٹول نہیں چلتا۔ ہر پیغام اصل جواب کی طرح ٹوکن خرچ کرتا ہے۔',
    testOnly: 'صرف ٹیسٹ: کچھ بھیجا یا محفوظ نہیں ہوتا',
    version: 'آزمانے کے لیے ورژن',
    versions: {
      draft: 'محفوظ کیا ہوا ڈرافٹ (ورژن {{version}})',
      published: 'لائیو ورژن ({{version}})',
    },
    unsaved:
      'کچھ تبدیلیاں محفوظ نہیں ہیں۔ ٹیسٹ محفوظ کیے ہوئے ڈرافٹ پر چلتا ہے، اس لیے انہیں آزمانے سے پہلے محفوظ کریں۔',
    noVersion: 'اس ایجنٹ کو آزمانے کے لیے پہلے ڈرافٹ محفوظ کریں۔',
    startOver: 'دوبارہ شروع کریں',
    you: 'آپ، کسٹمر کی طرح',
    ai: 'AI',
    message: 'آپ کا پیغام',
    messageHint: 'وہ لکھیں جو کوئی کسٹمر لکھ سکتا ہے۔',
    send: 'بھیجیں',
    thinking: 'AI جواب دے رہا ہے…',
    empty: 'شروع کرنے کے لیے پیغام لکھیں۔ ایسا سوال آزمائیں جو آپ کے کسٹمرز اکثر پوچھتے ہیں۔',
    tooLong: 'یہ ٹیسٹ گفتگو لمبی ہو گئی ہے۔ آگے آزمانے کے لیے دوبارہ شروع کریں۔',
    outcome: {
      customer_request:
        'کسٹمر نے کسی انسان سے بات کرنے کو کہا، اس لیے اصل گفتگو یہاں آپ کی ٹیم کے پاس جاتی۔',
      assist_mode:
        'یہ ایجنٹ صرف آپ کی ٹیم کو جواب تجویز کرتا ہے، اس لیے اصل گفتگو انہی کے پاس جاتی۔',
      ai_blocked:
        'AI اپنے اصولوں کی پابندی کرنے والا جواب نہیں لکھ سکا، اس لیے اصل گفتگو آپ کی ٹیم کے پاس جاتی۔',
      other: 'اصل گفتگو یہاں آپ کی ٹیم کے پاس جاتی۔',
    },
    errors: {
      auth: 'ماڈل پرووائیڈر نے API کلید یا اکاؤنٹ کو قبول نہیں کیا۔ ماڈل کنکشن چیک کریں۔',
      rate_limited: 'ماڈل پرووائیڈر درخواستیں محدود کر رہا ہے۔ تھوڑی دیر بعد دوبارہ کوشش کریں۔',
      overloaded: 'ماڈل پرووائیڈر مصروف ہے۔ تھوڑی دیر بعد دوبارہ کوشش کریں۔',
      unavailable: 'ماڈل پرووائیڈر ابھی دستیاب نہیں ہے۔',
      timeout: 'ماڈل کو جواب دینے میں بہت دیر لگی۔',
      aborted: 'درخواست روک دی گئی۔',
      invalid_request: 'ماڈل پرووائیڈر نے درخواست قبول نہیں کی۔ ماڈل کا نام اور ترتیبات چیک کریں۔',
      content_filtered: 'ماڈل پرووائیڈر کے فلٹر نے جواب روک دیا۔',
      context_length: 'گفتگو ماڈل کے لیے بہت لمبی ہے۔ دوبارہ شروع کریں۔',
      no_credentials: 'اس ماڈل کے لیے کوئی API کلید نہیں ہے۔ پہلے ماڈل کنکشن شامل کریں۔',
      connection_disabled: 'ماڈل کنکشن بند ہے۔ کوئی دوسرا کنکشن چنیں۔',
      provider_mismatch: 'ماڈل کنکشن اس پرووائیڈر کا نہیں ہے جسے چنا گیا ہے۔',
      model_not_allowed: 'اس کنکشن پر یہ ماڈل مجاز نہیں ہے۔',
      provider_not_supported: 'اس قسم کا ماڈل سپورٹڈ نہیں ہے۔',
      empty_reply: 'ماڈل نے کچھ نہیں کہا۔',
      unknown: 'ماڈل نے جواب نہیں دیا۔',
    },
    sources: 'استعمال کیے گئے ذرائع',
    actions: 'جو ٹولز اس نے مانگے',
    actionsNote: 'ٹولز یہاں کبھی نہیں چلتے۔ یہ دکھاتا ہے کہ اصل گفتگو میں کیا ہوتا۔',
    decisions: {
      would_run: 'ابھی چل جاتا',
      needs_approval: 'منظوری مانگتا',
      denied: 'اجازت نہیں',
      invalid: 'غلط تفصیل',
    },
    details: 'اس نے جو تفصیل بھیجی',
    steps: 'مراحل ({{total}})',
    stepsLabel: 'AI نے اس جواب کے لیے کیا کیا',
    stats: 'ماڈل {{model}} · ٹوکن: {{input}} اندر، {{output}} باہر · {{time}}',
    statsNoModel: 'کوئی ماڈل نہیں چلایا گیا · {{time}}',
  },
};
